export const ACCOUNT_TYPE = {
  RETAIL_REP: 'retail-rep',
  INTERIOR_DESIGN: 'interior-design',
  MULTIFAMILY: 'multifamily',
  ALCOVE: 'alcove',
};

export const SAMPLE_ACCOUNT_IDS = ['5786', '5788', '5789', '5791'];
export const ROLES = {
  user: 'User',
  'user-external': 'External User',
  admin: 'Admin',
  superadmin: 'Super Admin',
  'user-manager': 'User Manager',
} as const;

export const SESSION_STORAGE_KEYS = {
  DPR_BASELINE: 'dprBaseline',
};
